import React from 'react';

export interface TitleProps {
    label?: string; 
    children?: React.ReactNode;
}

export const Title: React.FC<TitleProps> = (props) => (
        <div className="">
            <h1 className='text-2xl h1-subpages mb-4'>{props.label ?? props.children}</h1>
        </div>
    )
